<tiime-input-container
  tiimeFormInputContainer
  contentId="userSelector"
  [label]="label"
  [small]="small"
  [required]="required"
  [errorMessage]="errorMessage?.message"
>
  <tiime-select
    id="userSelector"
    [customValue]="control.value?.fullName"
    [formControl]="control"
    [multiple]="multiple"
    (selectionChange)="emitSelectionChange($event)"
  >
    <div tiimeSelectOptions>
      @if (allowEmptyOption) {
        <mat-option [value]="null"></mat-option>
      }
      @for (user of selectorData; track trackById($index, user)) {
        <mat-option [value]="user">
          {{ user.fullName }}
          @if (displayEmail && user?.email) {
            <span class="user-email">- {{ user?.email }}</span>
          }
        </mat-option>
      }
      @if (allowCreateOption) {
        <mat-option (click)="emitCreate($event)">
          <div class="create-option-content">
            <mat-icon fontSet="fontastic" fontIcon="icon-add-fontastic"></mat-icon>
            <span>{{ createOptionLabel }}</span>
          </div>
        </mat-option>
      }
    </div>
  </tiime-select>
</tiime-input-container>
